import { Fragment, useMemo } from 'react';
import PropTypes from 'prop-types';

import { Dropdown } from 'basic-components';
import { DataTransformEnums } from 'dashboard-services/api/dataTransform';

import { FormulaUtils } from 'utils';

const OVERRIDDEN_DEFAULT = { label: FormulaUtils.OVERRIDDEN, value: FormulaUtils.OVERRIDDEN }
const PeriodTypeLocal = ({ onChange, value = undefined, periodTypeOverridden = false }) => {
  const defaultValue = useMemo(() => DataTransformEnums.PERIOD_TYPE_ARRAY.find(p => p.value === value), [value])
  return (
    <Fragment>
      <div
          className="ng-office-app__authed__content__body__item__expanded-settings__bottom__label"
          id="period-type"
      >
        Period Type
      </div>
      <div className="ng-office-app__authed__content__body__item__expanded-settings__bottom__value">
        <Dropdown
            defaultValue={periodTypeOverridden ? OVERRIDDEN_DEFAULT : defaultValue}
            disabled={periodTypeOverridden}
            fixed
            labelId="period-type"
            menuPortalTarget={document.querySelector('.ng-office-app')}
            name="periodType"
            noError
            onChange={onChange}
            options={DataTransformEnums.PERIOD_TYPE_ARRAY}
            variant="border"
        />
      </div>
    </Fragment>
  )
}

PeriodTypeLocal.propTypes = {
  onChange: PropTypes.func.isRequired,
  periodTypeOverridden: PropTypes.bool,
  value: PropTypes.string,
}

export default PeriodTypeLocal;
